import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useRoute } from 'vue-router';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import axios from 'axios';
import { useHomeStore } from '@/store';
import { useWindowResize } from '@/common/hooks/useWindowResize';
import thuFavicon from '@/assets/img/logo-thu.png';
import swjtuFavicon from '@/assets/logo/SWJTU.png';
import coalFavicon from '@/assets/logo/coal2.png';

import { watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const homeStore = useHomeStore();
    // 动态设置 favicon 的函数
    function changeFavicon(link) {
      let favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = link;
      } else {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = link;
        document.head.appendChild(favicon);
      }
    }
    /**
     * 根据用户来源设置对应品牌的浏览器图标。
     */
    const setFaviconBySource = () => {
      if (localStorage.getItem('from') === 'thu') {
        console.log('set favicon by thu');
        changeFavicon(thuFavicon); // 清华的 favicon
      } else if (localStorage.getItem('from') === 'MingChang') {
        changeFavicon('/logo-MingChang.ico'); // 銘昌的 favicon
      } else if (localStorage.getItem('from') === 'SWJTU') {
        changeFavicon(swjtuFavicon); // 西南交通大学的 favicon
      } else if (localStorage.getItem('from') === 'coal') {
        changeFavicon(coalFavicon);
      } else {
        // changeFavicon(coalFavicon);
        changeFavicon('/favicon.ico'); // 默认的 favicon
      }
    };
    watch(() => route.name, () => {
      if (localStorage.getItem('from') === 'thu') {
        document.title = '清华建筑设计院';
      } else if (localStorage.getItem('from') === 'MingChang') {
        document.title = '銘昌消防';
      } else if (localStorage.getItem('from') === 'SWJTU') {
        document.title = '西南交通大学';
      } else if (localStorage.getItem('from') === 'coal') {
        document.title = '煤炭消防安全管理平台';
      } else {
        document.title = process.env.VUE_APP_PROJECT_NAME ?? '默认标题';
        // document.title = '煤炭消防安全管理平台';
      }
      // 每次路由变化时都设置 favicon
      setFaviconBySource();
      if (route.meta && route.meta.title) {
        document.title += ' - ' + route.meta.title;
      }
    }, {
      immediate: true
    });
    // 监听 localStorage 的变化，当 "from" 改变时更新 favicon
    watch(() => localStorage.getItem('from'), () => {
      setFaviconBySource();
    });
    axios.get('/static/config.json').then(response => {
      let data = JSON.parse(JSON.stringify(response.data));
      let config = data['config'];
      if (config) {
        homeStore.setConfig(config);
        console.log('file config');
      } else {
        console.log('default config');
      }
    }).catch(error => {
      console.log(error);
      console.log('default config');
    });
    useWindowResize();
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});